<template>
  <div class="user row row--hover box box--default">
    <div
      class="row__data row__data--small row__data--image"
      @click="goToAccountDetails()"
    >
      <img v-if="userThumbnail" :src="userThumbnail" alt="" />
      <div v-else class="thumbnail thumbnail--user" :style="color">
        {{ parseInitials(user.first_name, user.last_name) }}
      </div>
    </div>
    <div
      class="row__data row__data--large row__data--name"
      @click="goToAccountDetails()"
    >
      {{ user.first_name }} {{ user.last_name }}
    </div>
    <div class="row__data row__data--medium">
      <a
        class="row__phone icon__phone"
        :href="user.phone ? `tel:${user.phone}` : 'javascript:void(0)'"
        :class="{ 'icon__phone--active': user.phone }"
      ></a>
      <a
        class="row__mail icon__mail"
        :href="user.email ? `mailto:${user.email}` : 'javascript:void(0)'"
        :class="{ 'icon__mail--active': user.email }"
      ></a>
    </div>
    <div
      class="row__data row__data--large row__data--team"
      
    >  

      <VSelect 
        v-if="teams && teams.length > 1"
        :options="teams"
        label="name"
        class="select select--default customer__dropdown"
        v-model="activeTeam"
        style="width: 100% !important; background-color: transparent !important; padding :0px !important; "
      /> 

      <div v-else-if="teams && teams.length == 1">
        <p style="color: var(--text-2);">{{ teams[0].name }}</p>
      </div>
       
      <span v-else>-</span>
    </div>
    <div
      class="row__data row__data--large row__data--team"
      @click="goToAccountDetails()"
    >
      <span v-if="user.company_name">{{ user.company_name }}</span>
      <span v-else>-</span>
    </div>
    <div
      class="row__data row__data--large row__data--address"
      @click="goToAccountDetails()"
    >
      {{ userAddress }}
    </div>
    <div
      class="row__data row__data--small row__data--zip"
      @click="goToAccountDetails()"
    >
      {{ userZip }}
    </div>
    <div
      class="row__data row__data--medium row__data--city"
      @click="goToAccountDetails()"
    >
      {{ userCity }}
    </div>
    <div
      class="row__data row__data--medium row__data--supervisor"
      @click="goToAccountDetails()"
    >
      {{ supervisor }}
    </div>
    <div
      class="row__data row__data--medium row__data--category"
      @click="goToAccountDetails()"
    >
      {{ saleCategory }}
    </div>
    <div
      class="row__data row__data--medium row__data--category"
      style="justify-content: center;"
    >
      <div v-if="user.approved" class="icon icon__active"></div> 
      <div v-else class="icon icon__inactive"></div> 
    </div>
    <div
      class="row__data row__data--small row__data--action "
      @click.self="showActionsDropdown = !showActionsDropdown"
    >
      <RowActionDropdown
        v-if="showActionsDropdown"
        @toggleDropdown="showActionsDropdown = $event"
        :onEdit="editUser"
        :onDelete="removeUser"
        :isActive = "user.approved"
        :onDisable = "disableTheUser"
        :onEnable = "enableTheUser"
      />
    </div>
  </div>
</template>

<script setup>
import { ref, computed, onMounted } from "vue";
import { useStore } from "vuex";
import { useRouter } from "vue-router";
import RowActionDropdown from "@/components/RowActionDropdown";
import statics from "@/statics";
import { parseInitials } from "@/helpers/entityParsers";

defineOptions({
  name: "User"
});

const props = defineProps({
  user: {
    required: true,
    type: Object,
  },
  deleteUser: {
    required: true,
    type: Function,
  },
});

const store = useStore();
const router = useRouter();

// State
const showActionsDropdown = ref(false);
const activeTeam = ref({});

// Computed
const saleCategory = computed(() => 
  props.user.sales_category ? props.user.sales_category.name_en || statics.empty : statics.empty
);

const supervisor = computed(() => 
  props.user.supervisor ? props.user.supervisor.first_name || statics.empty : statics.empty
);

const userThumbnail = computed(() => props.user.photo ? props.user.photo.thumbnail : null);

const primaryAddress = computed(() =>
  Array.isArray(props.user.user_addresses) ? props.user.user_addresses[0] : null
);

const userAddress = computed(() => 
  primaryAddress.value
    ? `${primaryAddress.value.street || statics.empty} ${primaryAddress.value.number || statics.empty}`
    : statics.empty
);

const userZip = computed(() => 
  primaryAddress.value?.zip || statics.empty
);

const userCity = computed(() => 
  primaryAddress.value?.city || statics.empty
);

const color = computed(() => 
  props.user.color ? { background: props.user.color } : { background: "#7f8fa4" }
);

const teams = computed(() => {
  if (!Array.isArray(props.user.teams)) return [];

  return props.user.teams.map((team) => ({
    id: team.id,
    name: team.name,
  }));
});

// Methods
const goToAccountDetails = () => {
  router.push({
    name: "AccountDetails",
    params: {
      entity: "user",
      id: props.user.id,
    },
  });
};

const editUser = () => {
  store.commit("setUserToEdit", props.user.id);
  store.commit("setIsEdit", true);
  store.commit("setShowAddUserModal", true);
};

const removeUser = () => {
  props.deleteUser({
    display: true,
    message: `'${props.user.first_name}'`,
    action: store._actions.deleteUser,
    id: props.user.id,
  });
};

const disableTheUser = () => {
  store.dispatch("disableUser", props.user.id);
};

const enableTheUser = () => {
  store.dispatch("enableUser", props.user.id);
};

onMounted(() => {
  if (teams.value.length) {
    const { id, name } = teams.value[0];
    activeTeam.value = { id, name };
  }
});
</script>
